// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"671":"services","933":"auth","945":"dashboard"}[chunkId] + "." + {"671":"ef7b6262","933":"1be948f7","945":"acc05f53"}[chunkId] + ".css";
};